import { render, staticRenderFns } from "./manage-messaging-services.vue?vue&type=template&id=21ade006&scoped=true"
import script from "./manage-messaging-services.vue?vue&type=script&lang=js"
export * from "./manage-messaging-services.vue?vue&type=script&lang=js"
import style0 from "./manage-messaging-services.vue?vue&type=style&index=0&id=21ade006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ade006",
  null
  
)

export default component.exports